import React from "react";
import Modal from "../modal/modal";
import PositionEnum from "../../enums/position.enum";
import SizeExtraEnum from "../../enums/size-extra.enum";
import { LessonMetadata } from "./lesson-information-modal-types";
import LessonInformation from "./lesson-information";
import "./lesson-information-modal.scss";

export interface ILessonInformationModalProps {
  lessonMetadata: LessonMetadata[];
  isPracticeEnabled: boolean;
  showStandards: boolean;
  showModal: boolean;
  handleClose: () => void;
  tier1ResourceToken: string;
}

const LessonInformationModal = (props: ILessonInformationModalProps) => {
  const { lessonMetadata, isPracticeEnabled, showStandards, tier1ResourceToken } = props;
  return (
    <Modal
      className="lesson-information-modal"
      size={SizeExtraEnum.XL}
      vPosition={PositionEnum.CENTER}
      showModal={props.showModal}
      handleClose={props.handleClose}
      title={<div className="title">Lesson Resources</div>}
      body={
        <LessonInformation
          lessonMetadata={lessonMetadata}
          isPracticeEnabled={isPracticeEnabled}
          showStandards={showStandards}
          tier1ResourceToken={tier1ResourceToken}
        />
      }
      showClose={true}
      scrollable={false}
      backdrop="static"
    />
  );
};

export default LessonInformationModal;
